import { render, staticRenderFns } from "./QRxLeaderboardDataTable.vue?vue&type=template&id=6c2310e0&scoped=true&"
import script from "./QRxLeaderboardDataTable.vue?vue&type=script&lang=js&"
export * from "./QRxLeaderboardDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QRxLeaderboardDataTable.vue?vue&type=style&index=0&id=6c2310e0&prod&scoped=true&lang=css&"
import style1 from "./QRxLeaderboardDataTable.vue?vue&type=style&index=1&id=6c2310e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2310e0",
  null
  
)

export default component.exports